/*
 * Shopify -> GA4 ecommerce event bridge.
 * Wraps fetch() to detect /cart/add, /cart/change, /cart/update, /cart/clear
 * and pushes GA4-shaped events to window.dataLayer.
 *
 * Loaded site-wide from layout/theme.liquid. Idempotent (guards against
 * double-install). No-ops gracefully if fetch is unavailable.
 *
 * Events emitted:
 *   - add_to_cart      after /cart/add.js
 *   - remove_from_cart after /cart/change.js with quantity 0
 *   - view_cart        on cart page load (Liquid-driven, see cart section)
 *
 * GA4 items[] shape uses item_id/item_name/item_brand/item_variant/price/quantity.
 */
(function () {
  if (window.__asbDlBridgeInstalled) return;
  window.__asbDlBridgeInstalled = true;
  if (typeof window.fetch !== 'function') return;

  var origFetch = window.fetch.bind(window);

  function lineToItem(line) {
    return {
      item_id: line.sku || String(line.product_id || line.id),
      item_name: line.product_title || line.title,
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      item_variant: line.variant_title || '',
      item_finish: line.variant_title || '',
      price: (line.final_price != null ? line.final_price : line.price) / 100,
      quantity: line.quantity || 1
    };
  }

  function pushEcom(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function getCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = origFetch(input, init);

    if (!url) return p;

    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (resp) {
        return resp.clone().json().catch(function () { return null; });
      }).then(function (body) {
        if (!body) return;
        var items = body.items ? body.items.map(lineToItem) : [lineToItem(body)];
        var value = items.reduce(function (s, it) { return s + (it.price || 0) * (it.quantity || 1); }, 0);
        pushEcom('add_to_cart', {
          ecommerce: {
            currency: (body.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'),
            value: Number(value.toFixed(2)),
            items: items
          }
        });
      }).catch(function () {});
    } else if (/\/cart\/change(\.js)?(\?|$)/.test(url) || /\/cart\/update(\.js)?(\?|$)/.test(url)) {
      Promise.all([p.then(function (r) { return r.clone().json().catch(function () { return null; }); }), getCart()])
        .then(function (results) {
          var afterCart = results[0];
          if (!afterCart || !init || !init.body) return;
          var bodyStr = '';
          try { bodyStr = typeof init.body === 'string' ? init.body : ''; } catch (e) {}
          if (bodyStr.indexOf('quantity=0') !== -1 || bodyStr.indexOf('"quantity":0') !== -1) {
            pushEcom('remove_from_cart', {
              ecommerce: {
                currency: afterCart.currency || 'USD',
                items: (afterCart.items || []).map(lineToItem)
              }
            });
          }
        }).catch(function () {});
    } else if (/\/cart\/clear(\.js)?(\?|$)/.test(url)) {
      p.then(function () {
        pushEcom('remove_from_cart', { ecommerce: { items: [] } });
      }).catch(function () {});
    }

    return p;
  };
})();
